var _excluded = ["as", "background", "borderColor", "borderStyle", "borderWidth", "borderBlockStartWidth", "borderBlockEndWidth", "borderInlineStartWidth", "borderInlineEndWidth", "borderRadius", "borderRadiusEndStart", "borderRadiusEndEnd", "borderRadiusStartStart", "borderRadiusStartEnd", "children", "color", "id", "minHeight", "minWidth", "maxWidth", "overflowX", "overflowY", "outlineColor", "outlineStyle", "outlineWidth", "padding", "paddingBlockStart", "paddingBlockEnd", "paddingInlineStart", "paddingInlineEnd", "role", "shadow", "tabIndex", "width", "printHidden", "visuallyHidden", "position", "insetBlockStart", "insetBlockEnd", "insetInlineStart", "insetInlineEnd", "zIndex", "opacity"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { forwardRef } from 'react';
import { getResponsiveProps, classNames, sanitizeCustomProperties } from '../../utilities/css.js';
import styles from './Box.scss.js';
var Box = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'div' : _ref$as,
      background = _ref.background,
      borderColor = _ref.borderColor,
      borderStyle = _ref.borderStyle,
      borderWidth = _ref.borderWidth,
      borderBlockStartWidth = _ref.borderBlockStartWidth,
      borderBlockEndWidth = _ref.borderBlockEndWidth,
      borderInlineStartWidth = _ref.borderInlineStartWidth,
      borderInlineEndWidth = _ref.borderInlineEndWidth,
      borderRadius = _ref.borderRadius,
      borderRadiusEndStart = _ref.borderRadiusEndStart,
      borderRadiusEndEnd = _ref.borderRadiusEndEnd,
      borderRadiusStartStart = _ref.borderRadiusStartStart,
      borderRadiusStartEnd = _ref.borderRadiusStartEnd,
      children = _ref.children,
      color = _ref.color,
      id = _ref.id,
      minHeight = _ref.minHeight,
      minWidth = _ref.minWidth,
      maxWidth = _ref.maxWidth,
      overflowX = _ref.overflowX,
      overflowY = _ref.overflowY,
      outlineColor = _ref.outlineColor,
      outlineStyle = _ref.outlineStyle,
      outlineWidth = _ref.outlineWidth,
      padding = _ref.padding,
      paddingBlockStart = _ref.paddingBlockStart,
      paddingBlockEnd = _ref.paddingBlockEnd,
      paddingInlineStart = _ref.paddingInlineStart,
      paddingInlineEnd = _ref.paddingInlineEnd,
      role = _ref.role,
      shadow = _ref.shadow,
      tabIndex = _ref.tabIndex,
      width = _ref.width,
      printHidden = _ref.printHidden,
      visuallyHidden = _ref.visuallyHidden,
      position = _ref.position,
      insetBlockStart = _ref.insetBlockStart,
      insetBlockEnd = _ref.insetBlockEnd,
      insetInlineStart = _ref.insetInlineStart,
      insetInlineEnd = _ref.insetInlineEnd,
      zIndex = _ref.zIndex,
      opacity = _ref.opacity,
      restProps = _objectWithoutProperties(_ref, _excluded);

  // eslint-disable-next-line no-nested-ternary
  var borderStyleValue = borderStyle ? borderStyle : borderColor || borderWidth || borderBlockStartWidth || borderBlockEndWidth || borderInlineStartWidth || borderInlineEndWidth ? 'solid' : undefined; // eslint-disable-next-line no-nested-ternary

  var outlineStyleValue = outlineStyle ? outlineStyle : outlineColor || outlineWidth ? 'solid' : undefined;

  var style = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
    '--pc-box-color': color ? "var(--p-color-".concat(color, ")") : undefined,
    '--pc-box-background': background ? "var(--p-color-".concat(background, ")") : undefined,
    // eslint-disable-next-line no-nested-ternary
    '--pc-box-border-color': borderColor ? borderColor === 'transparent' ? 'transparent' : "var(--p-color-".concat(borderColor, ")") : undefined,
    '--pc-box-border-style': borderStyleValue,
    '--pc-box-border-radius': borderRadius ? "var(--p-border-radius-".concat(borderRadius, ")") : undefined,
    '--pc-box-border-radius-end-start': borderRadiusEndStart ? "var(--p-border-radius-".concat(borderRadiusEndStart, ")") : undefined,
    '--pc-box-border-radius-end-end': borderRadiusEndEnd ? "var(--p-border-radius-".concat(borderRadiusEndEnd, ")") : undefined,
    '--pc-box-border-radius-start-start': borderRadiusStartStart ? "var(--p-border-radius-".concat(borderRadiusStartStart, ")") : undefined,
    '--pc-box-border-radius-start-end': borderRadiusStartEnd ? "var(--p-border-radius-".concat(borderRadiusStartEnd, ")") : undefined,
    '--pc-box-border-width': borderWidth ? "var(--p-border-width-".concat(borderWidth, ")") : undefined,
    '--pc-box-border-block-start-width': borderBlockStartWidth ? "var(--p-border-width-".concat(borderBlockStartWidth, ")") : undefined,
    '--pc-box-border-block-end-width': borderBlockEndWidth ? "var(--p-border-width-".concat(borderBlockEndWidth, ")") : undefined,
    '--pc-box-border-inline-start-width': borderInlineStartWidth ? "var(--p-border-width-".concat(borderInlineStartWidth, ")") : undefined,
    '--pc-box-border-inline-end-width': borderInlineEndWidth ? "var(--p-border-width-".concat(borderInlineEndWidth, ")") : undefined,
    '--pc-box-min-height': minHeight,
    '--pc-box-min-width': minWidth,
    '--pc-box-max-width': maxWidth,
    '--pc-box-outline-color': outlineColor ? "var(--p-color-".concat(outlineColor, ")") : undefined,
    '--pc-box-outline-style': outlineStyleValue,
    '--pc-box-outline-width': outlineWidth ? "var(--p-border-width-".concat(outlineWidth, ")") : undefined,
    '--pc-box-overflow-x': overflowX,
    '--pc-box-overflow-y': overflowY
  }, getResponsiveProps('box', 'padding-block-end', 'space', paddingBlockEnd || padding)), getResponsiveProps('box', 'padding-block-start', 'space', paddingBlockStart || padding)), getResponsiveProps('box', 'padding-inline-start', 'space', paddingInlineStart || padding)), getResponsiveProps('box', 'padding-inline-end', 'space', paddingInlineEnd || padding)), {}, {
    '--pc-box-shadow': shadow ? "var(--p-shadow-".concat(shadow, ")") : undefined,
    '--pc-box-width': width,
    position: position,
    '--pc-box-inset-block-start': insetBlockStart ? "var(--p-space-".concat(insetBlockStart, ")") : undefined,
    '--pc-box-inset-block-end': insetBlockEnd ? "var(--p-space-".concat(insetBlockEnd, ")") : undefined,
    '--pc-box-inset-inline-start': insetInlineStart ? "var(--p-space-".concat(insetInlineStart, ")") : undefined,
    '--pc-box-inset-inline-end': insetInlineEnd ? "var(--p-space-".concat(insetInlineEnd, ")") : undefined,
    zIndex: zIndex,
    opacity: opacity
  });

  var className = classNames(styles.Box, visuallyHidden && styles.visuallyHidden, printHidden && styles.printHidden, as === 'ul' && styles.listReset);
  return /*#__PURE__*/React.createElement(as, _objectSpread({
    className: className,
    id: id,
    ref: ref,
    style: sanitizeCustomProperties(style),
    role: role,
    tabIndex: tabIndex
  }, restProps), children);
});
Box.displayName = 'Box';
export { Box };